export default class LazyLoaderVideo {

  constructor () {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.videolazy"));

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove("videolazy");
            lazyVideoObserver.unobserve(video.target);

            $(video).css({
              'filter': 'none',
              'backgroundImage': 'none',
            });
          }
        });
      });

      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/lazy-loader-video.js